import { RouteComponentProps, withRouter } from "react-router-dom";
import { compose } from "recompose";

import CMS, { IProps, IRouteParams } from "./CMS.component";

export type IConnectedProps = RouteComponentProps<IRouteParams>;

export type IContainerProps = Omit<IProps, keyof IConnectedProps>;

export default compose<IProps, IContainerProps>(withRouter)(CMS);
